import { JSX } from "react";
import {
    CardWrapper,
    ProductBeverages,
    Tabs,
} from "@hatch-digital-nl/bravilor-storybook";
import { LanguageInterface } from "../../interfaces/shared/LanguageInterface";
import { ProductDetailInterface } from "../../interfaces/apiV2/product/ProductDetailInterface";
import { useProductSpecifications } from "../../hooks/productDetail/useProductSpecifications";
import { ProductSpecificationTabId } from "../../utils/productDetail/productSpecificationsConstants";
import { ProductSpecificationsBodySkeleton } from "./components/specifications/ProductSpecificationsBodySkeleton";
import { ProductSpecificationsGrid } from "./components/specifications/ProductSpecificationsGrid";

interface Props {
    data?: ProductDetailInterface;
    activeLanguage: LanguageInterface | null;
    loading: boolean;
}

export const ProductSpecifications = ({
    data,
    activeLanguage,
    loading,
}: Props): JSX.Element | null => {
    const {
        showSkeleton,
        showTabs,
        hasContent,
        tabs,
        cardTitle,
        specificationsLabel,
        activeTabId,
        setActiveTabId,
        specificationEntries,
        beveragesForDisplay,
        availableBeverageOptions,
        isBeveragesTabActive,
    } = useProductSpecifications({ data, activeLanguage, loading });

    if (!showSkeleton && !hasContent) {
        return null;
    }

    if (showSkeleton) {
        return (
            <CardWrapper isLoading>
                <ProductSpecificationsBodySkeleton />
            </CardWrapper>
        );
    }

    const bodyContent = isBeveragesTabActive ? (
        <div className="p-product-details__beverages">
            <ProductBeverages beverages={beveragesForDisplay} />
            {availableBeverageOptions ? (
                <p className="p-product-details__beverage-options">
                    {availableBeverageOptions}
                </p>
            ) : null}
        </div>
    ) : (
        <ProductSpecificationsGrid entries={specificationEntries} />
    );

    return (
        <CardWrapper
            title={showTabs ? cardTitle : specificationsLabel}
            titleAddon={
                showTabs ? (
                    <Tabs
                        tabs={tabs}
                        activeId={activeTabId}
                        onChange={(id: string) =>
                            setActiveTabId(id as ProductSpecificationTabId)
                        }
                    />
                ) : undefined
            }
            showHeaderDivider
        >
            {bodyContent}
        </CardWrapper>
    );
};
